import { PLAYVIDEO } from './type';

export const playVideo = (playVideo) => {
	return {
		type: PLAYVIDEO,
		object: playVideo
	};
};
